import React from 'react';

/**
 * PhotoCapture - Componente reutilizable que ofrece dos opciones:
 * 1. Tomar foto con la cámara del dispositivo
 * 2. Seleccionar imagen desde la galería/archivos
 *
 * En escritorio ambos botones abren el selector de archivos normal.
 * En móvil, el botón "Cámara" abre la cámara directamente.
 */
const PhotoCapture = ({ id, onCapture, preview, onClear }) => {
  const cameraId = `${id}-camera`;
  const galleryId = `${id}-gallery`;

  const handleFile = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => onCapture(e.target.result);
    reader.readAsDataURL(file);
  };

  return (
    <div>
      {/* Inputs ocultos */}
      <input
        id={cameraId}
        type="file"
        accept="image/*"
        capture="environment"
        style={{ display: 'none' }}
        onChange={(e) => handleFile(e.target.files[0])}
      />
      <input
        id={galleryId}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => handleFile(e.target.files[0])}
      />

      {!preview ? (
        /* Zona de selección con dos botones */
        <div style={{
          border: '2px dashed var(--glass-border)',
          borderRadius: '16px',
          padding: '20px 15px',
          background: 'var(--card-bg)',
          textAlign: 'center',
        }}>
          <i className="fa-solid fa-image" style={{ fontSize: '28px', color: 'var(--p-blue)', marginBottom: '12px', display: 'block' }} />
          <p style={{ margin: '0 0 16px 0', fontSize: '12px', color: 'var(--p-slate)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Seleccionar Evidencia Fotográfica
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            {/* Botón Cámara */}
            <button
              type="button"
              onClick={() => document.getElementById(cameraId).click()}
              style={{
                flex: 1,
                maxWidth: '160px',
                padding: '12px 10px',
                borderRadius: '12px',
                border: '1px solid rgba(14, 165, 233, 0.3)',
                background: 'rgba(14, 165, 233, 0.08)',
                color: 'var(--p-blue)',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s',
                fontFamily: 'var(--font-heading)',
                fontWeight: '700',
                fontSize: '12px',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(14, 165, 233, 0.18)'; e.currentTarget.style.borderColor = 'var(--p-blue)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(14, 165, 233, 0.08)'; e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.3)'; }}
            >
              <i className="fa-solid fa-camera" style={{ fontSize: '22px' }} />
              Tomar Foto
            </button>

            {/* Botón Galería */}
            <button
              type="button"
              onClick={() => document.getElementById(galleryId).click()}
              style={{
                flex: 1,
                maxWidth: '160px',
                padding: '12px 10px',
                borderRadius: '12px',
                border: '1px solid rgba(99, 102, 241, 0.3)',
                background: 'rgba(99, 102, 241, 0.08)',
                color: 'var(--p-indigo)',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s',
                fontFamily: 'var(--font-heading)',
                fontWeight: '700',
                fontSize: '12px',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99, 102, 241, 0.18)'; e.currentTarget.style.borderColor = 'var(--p-indigo)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(99, 102, 241, 0.08)'; e.currentTarget.style.borderColor = 'rgba(99, 102, 241, 0.3)'; }}
            >
              <i className="fa-solid fa-images" style={{ fontSize: '22px' }} />
              Desde Galería
            </button>
          </div>
        </div>
      ) : (
        /* Vista previa de la imagen seleccionada */
        <div style={{ position: 'relative', width: '100%' }}>
          <img
            src={preview}
            alt="Vista previa"
            style={{
              width: '100%',
              maxHeight: '160px',
              objectFit: 'cover',
              borderRadius: '14px',
              border: '1.5px solid var(--p-blue)',
              display: 'block',
            }}
          />
          {/* Botón para cambiar la foto */}
          <div style={{ display: 'flex', gap: '8px', marginTop: '10px', justifyContent: 'center' }}>
            <button
              type="button"
              onClick={() => document.getElementById(cameraId).click()}
              style={{ fontSize: '11px', padding: '6px 12px', borderRadius: '8px', border: '1px solid var(--glass-border)', background: 'var(--card-bg)', color: 'var(--p-slate)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <i className="fa-solid fa-camera" /> Retomar
            </button>
            <button
              type="button"
              onClick={() => document.getElementById(galleryId).click()}
              style={{ fontSize: '11px', padding: '6px 12px', borderRadius: '8px', border: '1px solid var(--glass-border)', background: 'var(--card-bg)', color: 'var(--p-slate)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <i className="fa-solid fa-images" /> Cambiar
            </button>
            <button
              type="button"
              onClick={onClear}
              style={{ fontSize: '11px', padding: '6px 12px', borderRadius: '8px', border: '1px solid rgba(244,63,94,0.3)', background: 'rgba(244,63,94,0.08)', color: 'var(--p-rose)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <i className="fa-solid fa-trash" /> Eliminar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoCapture;
